// extracted by mini-css-extract-plugin
export default {"header":"App_header__fhC8n","link":"App_link__kpF6Q","subLink":"App_subLink__qjnju","dropdownFooter":"App_dropdownFooter__4NEJ3"};